import React from 'react';
import Header from '../components/header';
import Footer from '../components/footer';
import Wallet from '../components/Wallet';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWallet } from '@fortawesome/free-solid-svg-icons';

const WalletPage = () => {
  return (
    <>
      <Header />
      <div className="container py-4" style={{ marginTop: '80px', marginBottom: '100px' }}>
        <div className="row mb-4">
          <div className="col-12">
            <h2>
              <FontAwesomeIcon icon={faWallet} className="me-2 text-primary" />
              My Wallet
            </h2>
            <p className="text-muted">Manage your coins and view transaction history</p>
          </div>
        </div>
        <Wallet />
      </div>
      <Footer page="wallet" />
    </>
  );
};

export default WalletPage; 